import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRoboto } from "shared/lib/styles";

export const StyledSnackbarMessage = styled.div`
  color: #ffffff;
  font-size: 16px;
  font-family: ${fontRoboto};
`;

export const StyledSnackbarAction = styled(BaseLink)`
  color: #4585ff;
  font-weight: 900;
  font-size: 16px;
  font-family: ${fontRoboto};
`;
